module.exports = __webpack_public_path__ + "img/yitifuwu.11e476b6.png";